import styled from "styled-components";

export const Dropdown = styled.div`
  position: relative;
  display: inline-block;
  width: ${(props) => (props.isButton ? `100% !important` : ``)};
  > ${DropdownButton} {
    width: ${(props) => (props.isButton ? `100% !important` : ``)};
  }

  input[type="checkbox"]:checked ~ div {
    display: block;
  }

  input {
    display: none;
  }

  @media screen and (min-width: 577px) {
    width: inherit;
    margin-bottom: 15px;
    margin-right: 10%;
  }
`;

export const DropdownButton = styled.button`
  background-color: transparent;
  color: #212529;
  padding: 0;
  font-size: 1rem;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;
  width: inherit;
  z-index: ${(props) => (props.inDrop ? `1 !important` : "")};
  width: ${(props) => (props.inDrop ? `100% !important` : ``)};

  /* :after {
    content: "▼";
    font-size: 70%;
    margin-left: 1%;
    position: relative;
  } */

  span {
    font-size: 70%;
  }

  label {
    padding: 5px;
    width: inherit;
    cursor: pointer;
  }
  @media screen and (min-width: 992px) {
    font-size: 1.5rem;
  }

  @media screen and (min-width: 577px) {
    font-size: 1.2rem;
  }
`;

export const DropdownContent = styled.div`
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  width: inherit;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;

  @media screen and (min-width: 1160px) {
    width: max-content;
  }
`;

export const DropdownItem = styled.a`
  color: black;
  padding: 8px 16px;
  text-decoration: none;
  display: block;
  font-size: 0.8rem;

  :hover {
    background-color: var(--orange);
    text-decoration: none;
    color: white;
    cursor: pointer;
  }

  @media screen and (min-width: 992px) {
    font-weight: 600;
  }
`;
